module.exports = __webpack_public_path__ + "img/IMG_1867_L_WoodMatted.c49ef782.jpg";